import React, { useState } from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { FaTachometerAlt, FaBox, FaTicketAlt, FaDollarSign, FaChartLine } from 'react-icons/fa';

import PackageDetailsModal from '../../../components/admin/AdminPackageManagement/PackageDetailsModal';
import AddPackageModal from '../../../components/admin/AdminPackageManagement/AddPackageModal';
import EditPackageModal from '../../../components/admin/AdminPackageManagement/EditPackageModal';
import PackageToast from '../../../components/admin/AdminPackageManagement/PackageToast';

import '../../../assets/css/admin/adminPackageManagement/packagemanagement.css';

  const PackageManagement = () => {
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [editingPackage, setEditingPackage] = useState(null);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [refreshPackages, setRefreshPackages] = useState(0);
  const [toast, setToast] = useState({ show: false, message: '', type: 'success' });
  const showToast = (message, type = 'success') => {
    setToast({ show: true, message, type });
    setTimeout(() => setToast({ show: false, message: '', type: 'success' }), 3000);
  };

  const openDetailsModal = (pkg) => {
    setSelectedPackage(pkg);
    setShowDetailsModal(true);
  };

  const openEditModal = (pkg) => {
    setEditingPackage(pkg);
    setShowEditModal(true);
  };

  const tabs = [
    { path: 'pack-dashboard', label: 'Dashboard', icon: FaTachometerAlt },
    { path: 'list', label: 'Packages', icon: FaBox },
    { path: 'bookings', label: 'Bookings', icon: FaTicketAlt },
    { path: 'revenue', label: 'Revenue', icon: FaDollarSign },
    { path: 'analytics', label: 'Analytics', icon: FaChartLine },
  ];

  return (
    <div className="adm-pkg-management-container">

      {/* Header */}
      <div className="adm-pkg-management-header">
        <div>
          <h1>Package Management</h1>
          <p>Manage travel packages, bookings, and revenue</p>
        </div>

        <button className="adm-pkg-btn-add" onClick={() => setShowAddModal(true)}>
          + Add New Package
        </button>
      </div>

      {/* Tabs */}
      <div className="adm-pkg-tabs-wrapper">
        {tabs.map(tab => {
          const Icon = tab.icon;
          return (
            <NavLink
              key={tab.path}
              to={tab.path}
              className={({ isActive }) =>
                `adm-pkg-tab-btn ${isActive ? 'adm-pkg-tab-active' : ''}`
              }
            >
              <Icon />
              <span>{tab.label}</span>
            </NavLink>
          );
        })}
      </div>

]      <div className="adm-pkg-tab-content">
        <Outlet context={{ openDetailsModal, openEditModal, showToast, refreshPackages }} />
      </div>

      {showDetailsModal && selectedPackage && (
        <PackageDetailsModal
          package={selectedPackage}
          onClose={() => setShowDetailsModal(false)}
          onEdit={openEditModal}
        />
      )}

      {showAddModal && (
  <AddPackageModal
    onClose={() => setShowAddModal(false)}
    onSuccess={() => {
        showToast('Package created successfully!');
        setRefreshPackages(prev => prev + 1);
    }}
/>
      )}

      {showEditModal && editingPackage && (
        <EditPackageModal
          package={editingPackage}
          onClose={() => setShowEditModal(false)}
          onSuccess={() => showToast('Package updated successfully!')}
        />
      )}

      {toast.show && (
        <PackageToast
          message={toast.message}
          type={toast.type}
          onClose={() => setToast({ show: false })}
        />
      )}
    </div>
  );
};

export default PackageManagement;